<template>
  <div style="margin-top:30px;">
    <el-form ref="form" :rules="rules" :model="form" label-width="110px">
      <el-form-item label="访问地址">
        <a :href="agreementUrl+16" target="_blank" rel="noopener noreferrer">{{ agreementUrl+16 }}</a>
      </el-form-item>
      <el-form-item label="车龄性质挂靠协议" prop="privacyAgreementShipper" label-width="200px" style="margin-right:15px">
        <myEditor v-model="form.privacyAgreementShipper" :disabled="false" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="funcSubmit">
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import myEditor from "@/components/MyEditor";

export default {
  name: "SiteEdit",
  components: {
    myEditor,
  },
  data() {
    return {
      agreementUrl: this.BASE_API_URL + "agreement/agreement.html?agreementType=",
      form: {
        code: "",
        privacyAgreementShipper: "",
        cancelAgreementShipper: "",
        userAgreementShipper: "",
        logisticsAgreementShipper: "",
        sdkAgreementShipper: "",
      },
      rules: {
        privacyAgreementShipper: [
          { required: true, message: "请输入隐私协议", trigger: "blur" },
        ],
        cancelAgreementShipper: [
          { required: true, message: "请输入注销协议", trigger: "blur" },
        ],
        userAgreementShipper: [
          { required: true, message: "请输入服务协议", trigger: "blur" },
        ],
        logisticsAgreementShipper: [
          { required: true, message: "请输入物流运输协议", trigger: "blur" },
        ],
        sdkAgreementShipper: [
          { required: true, message: "请输入SDK协议", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      const rLoading = this.openLoading("获取数据中...");
      return request({
        url: `/ntocc-basic-api/agreement/getAgreement`,
        params: { agreementType: 16 },
        method: "get",
      }).then((response) => {
        if (response.data) {
          this.form.code = response.data.code;
          this.form.privacyAgreementShipper =
            response.data.privacyAgreementShipper;
          this.form.cancelAgreementShipper =
            response.data.cancelAgreementShipper;
          this.form.userAgreementShipper = response.data.userAgreementShipper;
          this.form.logisticsAgreementShipper =
            response.data.logisticsAgreementShipper;
          this.form.sdkAgreementShipper = response.data.sdkAgreementShipper;
        }
        rLoading.close();
      });
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          request({
            url: "/ntocc-basic-api/agreement/saveAgreement",
            method: "post",
            data,
          }).then((response) => {
            this.getInfo();
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
          });
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "edit");
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
